import React from "react";

const paymentData = [
  {
    date: "27/04/2024",
    orderId: "ABC12345",
    product: "Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM",
    orderAmount: "₹ 50,000",
    fee: "₹ 1000",
    inHandAmount: "₹ 49,000",
    invoiceId: "#200902",
  },
  {
    date: "27/04/2024",
    orderId: "ABC12345",
    product: "Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM",
    orderAmount: "₹ 50,000",
    fee: "₹ 1000",
    inHandAmount: "₹ 49,000",
    invoiceId: "#200902",
  },
  {
    date: "27/04/2024",
    orderId: "ABC12345",
    product: "Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM",
    orderAmount: "₹ 50,000",
    fee: "₹ 1000",
    inHandAmount: "₹ 49,000",
    invoiceId: "#200902",
  },
  {
    date: "27/04/2024",
    orderId: "ABC12345",
    product: "Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM",
    orderAmount: "₹ 50,000",
    fee: "₹ 1000",
    inHandAmount: "₹ 49,000",
    invoiceId: "#200902",
  },
  {
    date: "27/04/2024",
    orderId: "ABC12345",
    product: "Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM",
    orderAmount: "₹ 50,000",
    fee: "₹ 1000",
    inHandAmount: "₹ 49,000",
    invoiceId: "#200902",
  },
  {
    date: "27/04/2024",
    orderId: "ABC12345",
    product: "Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM",
    orderAmount: "₹ 50,000",
    fee: "₹ 1000",
    inHandAmount: "₹ 49,000",
    invoiceId: "#200902",
  },
  {
    date: "27/04/2024",
    orderId: "ABC12345",
    product: "Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM",
    orderAmount: "₹ 50,000",
    fee: "₹ 1000",
    inHandAmount: "₹ 49,000",
    invoiceId: "#200902",
  },
  // Add more rows as needed
];

const AllPayments = () => {
  return (
    <div className="overflow-x-auto rounded-[10px] mt-[24px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)]">
      <table className="min-w-full bg-white">
        <thead className="bg-[#F2F2F2] font-semibold text-[14px] h-[61px]">
          <tr>
            <th className="px-4 py-2 font-semibold">Date</th>
            <th className="px-4 py-2 w-[100px] font-semibold">Order id</th>
            <th className="px-4 py-2 w-[400px] font-semibold">Product</th>
            <th className="px-4 py-2 font-semibold">Order Amount</th>
            <th className="px-4 py-2 font-semibold">Naayatrade Fee</th>
            <th className="px-4 py-2 font-semibold">In Hand Amount</th>
            <th className="px-4 py-2 font-semibold">Invoice ID</th>
            <th className="px-4 py-2 font-semibold">Invoice</th>
          </tr>
        </thead>
        <tbody className="[&>*:nth-child(even)]:bg-[#F8F8F8] [&>*:nth-child(odd)]:bg-white font-medium text-[12px]">
          {paymentData.map((inquiry, index) => (
            <tr key={index} className="text-center h-[70px]">
              <td className="px-4 py-2">{inquiry.date}</td>
              <td className="px-4 py-2">{inquiry.orderId}</td>
              <td className="px-4 py-2 flex items-center h-[70px] text-start">
                <img
                  src={require("../../../assets/SellerDashboard/SellerPayment/image 410.jpg")}
                  alt="Product"
                  className="w-[24px] h-[34px] mr-[15px]"
                />
                <div>{inquiry.product}</div>
              </td>
              <td className="px-4 py-2">{inquiry.orderAmount}</td>
              <td className="px-4 py-2">{inquiry.fee}</td>
              <td className="px-4 py-2">{inquiry.inHandAmount}</td>
              <td className="px-4 py-2">{inquiry.invoiceId}</td>
              <td className="px-4 py-2">
                {" "}
                <a
                  href="path/to/invoice.pdf"
                  className="text-orange-500 hover:underline flex items-center justify-center"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1007_17164)">
                      <path
                        d="M4 17V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V17"
                        stroke="#FF6300"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 11L12 16L17 11"
                        stroke="#FF6300"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 4V16"
                        stroke="#FF6300"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1007_17164">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllPayments;
